interface DocumentFileIconProps {
  className?: string
}

export const DocumentFileIcon = ({ className }: DocumentFileIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="44"
    fill="none"
    viewBox="0 0 40 44"
    className={className}
  >
    <path
      fill="#2962FF"
      d="M29.563 4h-14.32l-.727.728L4.454 14.789l-.727.728v21.772c0 3.7 3.01 6.711 6.71 6.711h19.126c3.7 0 6.71-3.01 6.71-6.71V10.71c0-3.7-3.01-6.71-6.71-6.71m4.225 33.29a4.225 4.225 0 0 1-4.225 4.225H10.437a4.226 4.226 0 0 1-4.226-4.226V16.546h6.54a3.52 3.52 0 0 0 3.522-3.52V6.484h13.29a4.225 4.225 0 0 1 4.225 4.225z"
    ></path>
    <path
      fill="#2962FF"
      d="M28.658 11.279h-6.982v6.982h6.982zM28.658 22.171H11.342v1.955h17.316zM28.658 27.757H11.342v1.955h17.316zM28.658 33.343H11.342v1.955h17.316zM18.333 10a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0"
    ></path>
    <path
      fill="#fff"
      d="M13.36 7.475a.625.625 0 0 1 0 .884l-4.167 4.166a.625.625 0 0 1-.884 0L6.642 10.86a.625.625 0 0 1 .884-.884L8.75 11.2l1.862-1.863 1.862-1.862a.625.625 0 0 1 .884 0"
    ></path>
  </svg>
)
